module.exports = __webpack_public_path__ + "img/infirmary-logo.460021bd.jpg";